// extracted by mini-css-extract-plugin
export default {"typo":"Typography_typo__LyknQ","title":"Typography_title__3P3uW","subtitle":"Typography_subtitle__124AS"};